<template>
  <WsMain>
    <WsCRUD
      v-if="isMounted"
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :sortBy="sortBy"
      :showFields="showFields"
      :pageMode="true"
      :showExpand="false"
      :rowClickRead="true"
      :liveSearching="true"
      :isMultiSelect="true"
      :customParams="_customParams"
      @rowClickInput="$_onClickItem($event)"
    />
  </WsMain>
</template>

<script>
import model from '@/models/option';
import S_questionType from '@/services/api/v1/questionType';

export default {
  data() {
    return {
      modelName: model.modelName,
      label: model.label,
      fields: model.fields,
      showFields: [
        'sequence',
        'name',
        'updated_at',
        'updated_admin',
      ],
      sortBy: 'sequence',
      singleChoiceId: null,
      isMounted: false,
    }
  },
  computed: {
    _customParams() {
      return {
        question_type: this.singleChoiceId,
        type: 'option',
      };
    }
  },
  async mounted() {
    this.singleChoiceId = await this.$_getSingleChoiceId();
    this.isMounted = true;
  },
  methods: {
    async $_getSingleChoiceId() {
      const res = await S_questionType.index();
      const questionType = res.find(type => type.value === 'single-choice');
      return questionType.id;
    },
    $_onClickItem($event) {
      this.$router.push(`/option/${$event}`);
    }
  }
};
</script>